module.exports = __webpack_public_path__ + "img/avatar.91423fb5.jpg";